/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {LocateFilter} from "./locateFilter";

export class LocateFilters {
  locationFilters: LocateFilter[];
  assetFilters: LocateFilter[];
  peopleFilters: LocateFilter[];
}
